(() => {
  if (window.ldsBookQuizInitialized) return;
  window.ldsBookQuizInitialized = true;

  // Load the existing consent API; never change the visitor's consent.
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
    } catch (_) { /* Tracking stays off if privacy permissions cannot be checked. */ }
  }

  function track(root, action) {
    if (root.dataset.quizTracking !== 'true' || window.Shopify?.designMode) return;
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
      // Fixed metadata only: no answers, result, identity, product URL or visitor IDs.
      const data = { quiz_name: 'book_ticket', placement: 'homepage' };
      try {
        const published = window.Shopify?.analytics?.publish?.(`lds:${action}`, data);
        if (published && typeof published.catch === 'function') published.catch(() => {});
      } catch (_) { /* A failed subscriber must never break the quiz. */ }
      const destination = root.dataset.quizGa4Id || '';
      if (/^G-[A-Z0-9]+$/.test(destination) && typeof window.gtag === 'function') {
        window.gtag('event', action.replace(/-/g, '_'), {
          ...data,
          send_to: destination,
          transport_type: 'beacon',
          theme_preview: window.Shopify?.theme?.role !== 'main',
          debug_mode: window.Shopify?.theme?.role !== 'main'
        });
      }
    } catch (_) { /* Analytics is optional and must not affect shopping. */ }
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-home-books]').forEach(root => {
      const quiz = root.querySelector('[data-book-quiz]');
      if (!quiz || quiz.dataset.initialized) return;
      quiz.dataset.initialized = 'true';

      const open = quiz.querySelector('[data-quiz-open]');
      const card = quiz.querySelector('[data-quiz-card]');
      const close = quiz.querySelector('[data-quiz-close]');
      const steps = [...quiz.querySelectorAll('[data-quiz-step]')];
      const result = quiz.querySelector('[data-quiz-result]');
      const restart = quiz.querySelector('[data-quiz-restart]');
      const controls = root.querySelector('[data-home-book-controls]');
      const books = [...root.querySelectorAll('[data-home-pane]')];
      let scores = {};
      let lastPick = [];
      let running = false;
      let matchedId = null;
      let shopCounted = false;

      open.hidden = false;

      function showStep(index) {
        steps.forEach((step, i) => step.hidden = i !== index);
        result.hidden = true;
        const first = steps[index] && steps[index].querySelector('button');
        if (first) first.focus({ preventScroll: true });
      }

      function start() {
        if (running) return;
        running = true;
        matchedId = null;
        shopCounted = false;
        scores = {};
        lastPick = [];
        card.hidden = false;
        open.hidden = true;
        open.setAttribute('aria-expanded', 'true');
        if (controls) controls.hidden = true;
        showStep(0);
        track(root, 'quiz-opened');
      }

      function finish() {
        if (!running) return;
        if (controls) controls.hidden = false;
        card.hidden = false;
        open.hidden = true;
        const labels = books.map(b => b.dataset.quizLabel);
        let winner = null;
        let best = -1;
        // Highest score wins; ties go to the reader's most recent answer, then button order.
        labels.forEach(label => {
          const score = scores[label] || 0;
          const tieBreak = lastPick.includes(label);
          if (score > best || (score === best && tieBreak && !lastPick.includes(winner))) {
            best = score;
            winner = label;
          }
        });
        const ticket = books.find(b => b.dataset.quizLabel === winner) || books[0];
        if (!ticket) return;
        root.dispatchEvent(new CustomEvent('lds:book-select', { detail: { id: ticket.dataset.homePane } }));
        steps.forEach(step => step.hidden = true);
        result.querySelector('[data-quiz-result-name]').textContent = ticket.dataset.title.replace(/^Book Club Ticket\s*-\s*/, '');
        result.querySelector('[data-quiz-result-blurb]').textContent = ticket.dataset.quizBlurb || '';
        result.hidden = false;
        running = false;
        matchedId = ticket.dataset.homePane;
        track(root, 'quiz-completed');
        result.focus({ preventScroll: true });
      }

      function reset() {
        running = false;
        card.hidden = true;
        open.hidden = false;
        open.setAttribute('aria-expanded', 'false');
        if (controls) controls.hidden = false;
        open.focus({ preventScroll: true });
      }

      open.addEventListener('click', start);
      close.addEventListener('click', reset);
      restart.addEventListener('click', start);

      root.addEventListener('click', event => {
        const link = event.target.closest?.('[data-home-link] a, [data-home-pane] a.home-book-image');
        if (!link || !root.contains(link) || !matchedId || shopCounted || running) return;
        const holder = link.closest('[data-home-link], [data-home-pane]');
        if (!holder || holder.hidden) return;
        const id = holder.dataset.homeLink || holder.dataset.homePane;
        if (id !== matchedId) return;
        shopCounted = true;
        track(root, 'shop-clicked');
      });
      // Browsing a different ticket after the result is not a matched-result click.
      root.addEventListener('lds:book-select', event => {
        if (!running && matchedId && event.detail?.id !== matchedId) matchedId = null;
      });
      root.querySelectorAll('[data-home-book]').forEach(button => {
        button.addEventListener('click', () => {
          if (matchedId && button.dataset.homeBook !== matchedId) matchedId = null;
        });
      });

      steps.forEach((step, index) => {
        step.querySelectorAll('[data-quiz-answer]').forEach(answer => {
          answer.addEventListener('click', () => {
            if (!running || step.hidden) return;
            lastPick = answer.dataset.quizAnswer.split(',').map(s => s.trim()).filter(Boolean);
            const weight = Number(step.dataset.quizWeight) || 1;
            lastPick.forEach(label => scores[label] = (scores[label] || 0) + weight);
            if (index + 1 < steps.length) showStep(index + 1);
            else finish();
          });
        });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
